import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export function ObjectionsSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-86">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-87">
        {/* For You */}
        <div className="bg-green-50 rounded-2xl p-8 md:p-12 border-4 border-green-500 shadow-xl" data-id="element-88">
          <h3 className="text-3xl font-black text-green-800 mb-8 uppercase text-center" data-id="element-89">
            Esto ES para vos si:
          </h3>
          <ul className="space-y-6" data-id="element-90">
            {['Sentís que estás estancado', 'No sabés qué hacer cada día', 'Publicás pero no vendés', 'Te cuesta cerrar'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-91">
                <div className="bg-green-500 rounded-full p-1 mt-1 flex-shrink-0" data-id="element-92">
                  <CheckIcon className="w-6 h-6 text-white" strokeWidth={3} data-id="element-93" />
                </div>
                <span className="text-xl font-bold text-gray-800" data-id="element-94">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div className="bg-red-50 rounded-2xl p-8 md:p-12 border-4 border-red-500 shadow-xl" data-id="element-95">
          <h3 className="text-3xl font-black text-red-800 mb-8 uppercase text-center" data-id="element-96">
            Esto NO es para vos si:
          </h3>
          <ul className="space-y-6" data-id="element-97">
            {['Buscás resultados sin hacer nada', 'Querés “hackear” el sistema', 'No estás dispuesto a ejecutar'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-98">
                <div className="bg-red-500 rounded-full p-1 mt-1 flex-shrink-0" data-id="element-99">
                  <XIcon className="w-6 h-6 text-white" strokeWidth={3} data-id="element-100" />
                </div>
                <span className="text-xl font-bold text-gray-800" data-id="element-101">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}